import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from './Login';

function App() {
  return (
    <div className="App">
      <Login/>
    </div>
  );
}

export default App;
